import { deserialize } from 'class-transformer';

export class JsonSerializer {
	serialize(value: any): any {
		return JSON.stringify(value);
	}

	deserialize<T>(type: any, value: any): T {
		return deserialize(type, value);
	}
}